var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data[_vm.column].updateBy)?[_vm._v(_vm._s(_vm.data[_vm.column].updateBy)+" "),_c('br')]:_vm._e(),(_vm.data[_vm.column].updateDatetime)?[_vm._v(_vm._s(_vm.data[_vm.column].updateDatetime)+" "),_c('br')]:_vm._e(),(_vm.data[_vm.column].duration)?[_vm._v(_vm._s(_vm.data[_vm.column].duration)+" ")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }